export const isEmptyString = (str: string) => {
  return str ? str.trim() === '' : false
}
